import axios from 'axios'
import { baseUrl } from './config'

export function getStatisticsRoundsMines (params) {
  return axios.get(`${baseUrl}/mines-game/games`, {
    params
  })
}

export function getGeneralStatistics () {
  return axios.get(`${baseUrl}/mines-game/statistics`)
}

export function startMines () {
  return axios.post(`${baseUrl}/mines-game/start`)
}

export function stopMines () {
  return axios.post(`${baseUrl}/mines-game/stop`)
}
